export const onlyNumbersRegex = /^\d+$/;
export const onlyNumberRegex = /\d/;
export const onlyNumberGlobalRegex = /\D/g;
export const phoneCodeRegex = /^(\d{0,3})/;
export const fullPhoneNumberRegex = /^(\d{0,3})(\d{0,3})(\d{0,4})/;
export const phoneNumberBeforeDashRegex = /^(\d{0,3})(\d{0,3})/;
